
import React, { useState } from 'react';
import FilterPage from './FilterPage';
import PrintPage from './PrintPage';
import './print.css';

function App() {
  const [filter, setFilter] = useState(null);

  return (
    <div>
      {!filter ? (
        <FilterPage onFilter={setFilter} />
      ) : (
        <PrintPage filter={filter} onBack={() => setFilter(null)} />
      )}
    </div>
  );
}

export default App;
